export const API_CONFIG = {
  apiUrl: 'https://anuax-hakikat.web.app/api/v1'
  // apiUrl: 'http://127.0.0.1:5001/anuax-hakikat/europe-west3/api_v1/api/v1'
};

export const FIREBASE_CONFIG = {
  projectId: "anuax-hakikat",
  appId: "1:271850291292:web:06082d34669b2934c42699",
  apiKey: "AIzaSyBoDiZQhSV6HKntojE-yknw4U0MSh6tcZ8",
  authDomain: "anuax-hakikat.firebaseapp.com",
  measurementId: "G-MR35W12935",
  messagingSenderId: "271850291292",
  storageBucket: "anuax-hakikat.firebasestorage.app",
};